export default __webpack_public_path__ + "static/media/download.bf97969d.svg";